import '../../scss/style.scss';
import jQuery from 'jquery';
// import { gWindowWidth } from '../modules/gWidth';

const $ = jQuery;
window.jQuery = jQuery;

window.bst = {};
// var gWwidth = gWindowWidth();
// var ua = navigator.userAgent.toLowerCase();
// var isIE = ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0;
// var android4xFlg = ua.indexOf('android 4') > 0;
// var isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent);

jQuery.extend(jQuery.easing, {
  def: 'easeOutQuad',
  easeOutQuart: function (x, t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  },
  easeOutExpo: function (e, f, a, h, g) {
    return f === g ? a + h : h * (-Math.pow(2, -10 * f / g) + 1) + a;
  },
  quart: function (x, t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  }
});

// win8.1 ie11 mousewheel scroll bug
if (navigator.userAgent.match(/Trident\/7\./)) {
  $('body').on('mousewheel', function () {
    event.preventDefault();
    var wheelDelta = event.wheelDelta;
    var currentScrollPosition = window.pageYOffset;
    window.scrollTo(0, currentScrollPosition - wheelDelta);
  });
}

// 最初に実行する関数
$(window).on({
  load: function () {
    // gWwidth = gWindowWidth();

    headerScr();
  },
  resize: function () {
    // gWwidth = gWindowWidth();

    headerScr();
  },
  scroll: function () {
    headerScr();
  }
});

// #リンク
$('a[href^="#"]').click(function (e) {
  e.preventDefault();
});

// header scr
var $header = $('.l-header');
var startPos = 0;
function headerScr () {
  var headerHeight = $header.outerHeight();
  var scr = $(window).scrollTop();

  if (scr > startPos && scr > headerHeight) {
    $header.addClass('scr');
  } else {
    $header.removeClass('scr');
  }
  startPos = scr;

  if (scr > 0) {
    $header.addClass('sha');
  } else {
    $header.removeClass('sha');
  }
}

// register modal kiyaku - demo
// var isRegisterKiyaku = false;
function isRegisterKiyakuCheck () {
  if ($('.c-btn--doui').hasClass('is-checked')) {
    $('.c-btn--register').addClass('is-active');
  } else {
    $('.c-btn--register').removeClass('is-active');
  }
}

$('.c-btn--doui a').click(function () {
  $('.c-btn--doui').toggleClass('is-checked');
  isRegisterKiyakuCheck();
});



// WEBPACK FOOTER //
// ./src/js/entries/main.js